import { pxToRem } from '@deltek/specification-client/core/Utilities/unitUtils'
import { IconButton } from '@material-ui/core'
import { OverridableComponent } from '@material-ui/core/OverridableComponent'
import { makeStyles, Theme } from '@material-ui/core/styles'
import { SvgIconTypeMap } from '@material-ui/core/SvgIcon'
import SearchIcon from '@material-ui/icons/Search'
import clsx from 'clsx'
import React from 'react'
import FilterIcon from 'resources/FilterIcon'
import TwoColumnIcon from 'resources/TwoColumnIcon'

const useButtonStyles = makeStyles((theme: Theme) => ({
    iconButtonWidget: {
        padding: 0,
        color: theme.palette.common.white,
    },
    defaultIconStyle: {
        width: 'auto',
        height: 'auto',
    },
    iconClicked: {
        background:
            'linear-gradient(180deg, rgba(255, 145, 0, 0.45) 0%, rgba(255, 255, 255, 0) 100%)',
        border: '1px solid rgba(255, 255, 255, 0.35)',
        filter: 'drop-shadow(0px 8px 16px #3A3A3A)',
        borderRadius: pxToRem(4),
        height: '100%',
        padding: theme.spacing(0.625),
    },
}))

export interface WorkspaceActionBarIconButtonWidgetProps {
    onClick?: (toggleDisplay?: boolean) => void
    icon: OverridableComponent<SvgIconTypeMap>
    name?: string
    isActive?: boolean
    disabled?: boolean
}

const WorkspaceActionBarIconButtonWidget: React.FC<WorkspaceActionBarIconButtonWidgetProps> = ({
    onClick,
    icon,
    name,
    isActive,
    disabled,
}) => {
    const WidgetIcon = React.useMemo(() => icon, [icon])
    const classes = useButtonStyles()
    const [isClicked, setIsClicked] = React.useState<boolean>(isActive ?? false)

    const handleClicked = () => {
        if (WidgetIcon === TwoColumnIcon || WidgetIcon === SearchIcon) {
            setIsClicked(!isClicked)
            onClick?.(!isClicked)
        } else {
            onClick?.()
        }
    }

    return (
        <IconButton
            size="small"
            onClick={handleClicked}
            aria-label={`rightWidget-${name}`}
            className={clsx(
                classes.iconButtonWidget,
                isClicked && classes.iconClicked
            )}
            data-testid={`rightWidget-${name}`}
            disabled={disabled}
        >
            {WidgetIcon && (
                <WidgetIcon
                    className={clsx(
                        (WidgetIcon === TwoColumnIcon ||
                            WidgetIcon === FilterIcon) &&
                            classes.defaultIconStyle
                    )}
                />
            )}
        </IconButton>
    )
}

export default WorkspaceActionBarIconButtonWidget
